import { VendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';

import {
  CANONICAL_FACET_TEXT_OVERRIDES_SENTENCE_CASE,
  CANONICAL_FACET_TEXT_OVERRIDES_TITLE_CASE,
} from '~/util/seoUtils';

import { pickCanonicalFacets } from '../../../util/canonicalUrl';
import { VendorSearchRequest } from '../types/types';

export const getCanonicalFacetDescription = (
  selectedTaxonomy?: VendorTaxonomyKey,
  selectedFacets?: VendorSearchRequest['selectedFacets'],
  titleCase = false
): string | undefined => {
  const canonicalFacets = pickCanonicalFacets(selectedTaxonomy, selectedFacets || [], true);

  if (canonicalFacets.length === 1) {
    const facetKey = canonicalFacets[0].key;

    const overrides = titleCase
      ? CANONICAL_FACET_TEXT_OVERRIDES_TITLE_CASE()
      : CANONICAL_FACET_TEXT_OVERRIDES_SENTENCE_CASE();

    if (facetKey in overrides) {
      const override = overrides[facetKey as keyof typeof overrides];

      if (override) {
        return override;
      }
    }

    return canonicalFacets[0].displayName || canonicalFacets[0].name;
  }

  return undefined;
};
